import React, { useState, useEffect } from "react";
import OnePmsPosImage from "../../../assets/laptop-image.png";
import Arrow1 from "../../../assets/arrow-1.png";
import Arrow2 from "../../../assets/arrow-2.png";
import Arrow3 from "../../../assets/arrow-3.png";
import { Link } from "react-router-dom";

function IntroducingSection({ acfData }) {
  const [pmsPosData, setPmsPosData] = useState({
    introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title:
      "Introducing the All in One PMS, POS and Tour Booking Platform",
    introducing_the_all_in_one_pms_pos_and_tour_booking_platform: [],
    one_pms_pos_and_tour_booking_section_button_text: "Request A Demo",
    one_pms_pos_and_tour_booking_platform_button_url:
      "/contact-us",
    one_pms_pos_and_tour_booking_section_tag_line_text: "Your staff will thank you",
    one_pms_pos_and_tour_booking_section_image: OnePmsPosImage,
  });

  useEffect(() => {
    if (acfData) {
      const {
        introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title,
        introducing_the_all_in_one_pms_pos_and_tour_booking_platform,
        one_pms_pos_and_tour_booking_section_button_text,
        one_pms_pos_and_tour_booking_platform_button_url,
        one_pms_pos_and_tour_booking_section_tag_line_text,
        one_pms_pos_and_tour_booking_section_image,
      } = acfData;

      setPmsPosData((prev) => ({
        ...prev,
        introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title:
          introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title ||
          prev.introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title,
        introducing_the_all_in_one_pms_pos_and_tour_booking_platform:
          introducing_the_all_in_one_pms_pos_and_tour_booking_platform || [],
        one_pms_pos_and_tour_booking_section_button_text:
          one_pms_pos_and_tour_booking_section_button_text ||
          prev.one_pms_pos_and_tour_booking_section_button_text,
        one_pms_pos_and_tour_booking_platform_button_url:
          one_pms_pos_and_tour_booking_platform_button_url ||
          prev.one_pms_pos_and_tour_booking_platform_button_url,
        one_pms_pos_and_tour_booking_section_tag_line_text:
          one_pms_pos_and_tour_booking_section_tag_line_text ||
          prev.one_pms_pos_and_tour_booking_section_tag_line_text,
        one_pms_pos_and_tour_booking_section_image:
          one_pms_pos_and_tour_booking_section_image?.url ||
          prev.one_pms_pos_and_tour_booking_section_image,
      }));
    }
  }, [acfData]);

  const {
    introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title,
    introducing_the_all_in_one_pms_pos_and_tour_booking_platform,
    one_pms_pos_and_tour_booking_section_button_text,
    one_pms_pos_and_tour_booking_platform_button_url,
    one_pms_pos_and_tour_booking_section_tag_line_text,
    one_pms_pos_and_tour_booking_section_image,
  } = pmsPosData;

  const leftLabels = introducing_the_all_in_one_pms_pos_and_tour_booking_platform.slice(
    0,
    3
  );
  const rightLabels = introducing_the_all_in_one_pms_pos_and_tour_booking_platform.slice(
    3,
    6
  );

  return (
    <section className="py-14 -mt-[130px]">
      <div className="flex flex-col gap-y-8 w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap items-center -mx-4 gap-y-4">
          <div className="w-full max-w-full px-4">
            <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-[#5fa3b2] text-center">
              {introducing_the_all_in_one_pms_pos_and_tour_booking_platform_title}
            </h2>
          </div>

          {/* LEFT LABELS */}
          <div className="hidden lg:block lg:w-1/12 max-w-full px-4 text-center">
            <ul className="flex flex-col mb-[80px] gap-y-[50px] xl:gap-y-[90px] mr-[-100px] xl:mr-[-120px] min-[1560px]:mr-[-220px]">
              {leftLabels.map((item, index) => (
                <li key={index}>
                  <h3 className="text-2xl font-bold text-[#111111] max-w-[166px] text-end ml-auto relative">
                    {item?.pms_pos_and_tour_booking_lable}
                    <img
                      src={index === 0 ? Arrow1 : index === 1 ? Arrow2 : Arrow3}
                      alt="Arrow"
                      className="ml-auto relative left-[25px]"
                      height="28"
                      width="58"
                    />
                  </h3>
                </li>
              ))}
            </ul>
          </div>

          {/* IMAGE */}
          <div className="w-full lg:w-10/12 max-w-full px-4 text-center">
            <img
              src={one_pms_pos_and_tour_booking_section_image}
              alt="Laptop"
              className="mx-auto"
            />
          </div>

          {/* RIGHT LABELS */}
          <div className="hidden lg:block lg:w-1/12 max-w-full px-4 text-center">
            <ul className="flex flex-col mb-[80px] gap-y-[50px] xl:gap-y-[90px] ml-[-100px] xl:ml-[-120px] min-[1560px]:ml-[-220px]">
              {rightLabels.map((item, index) => (
                <li key={index}>
                  <h3 className="text-2xl font-bold text-[#111111] max-w-[166px] text-start mr-auto relative">
                    {item?.pms_pos_and_tour_booking_lable}
                    <img
                      src={index === 0 ? Arrow1 : index === 1 ? Arrow2 : Arrow3}
                      alt="Arrow"
                      className="mr-auto relative right-[15px] -scale-x-100"
                      height="28"
                      width="58"
                    />
                  </h3>
                </li>
              ))}
            </ul>
          </div>

          {/* MOBILE LABEL GRID */}
          <div className="lg:hidden w-full max-w-full px-4 text-center">
            <div className="flex flex-wrap divide divide-[#DDDDDD]">
              {introducing_the_all_in_one_pms_pos_and_tour_booking_platform.map(
                (item, index) => (
                  <div
                    key={index}
                    className="w-1/2 p-4 border border-t-0 border-l-0 border-r-0"
                  >
                    <h3 className="text-xl sm:text-2xl font-bold text-[#111111]">
                      {item?.pms_pos_and_tour_booking_lable}
                    </h3>
                  </div>
                )
              )}
            </div>
          </div>

          {/* BUTTON + TAGLINE */}
          <div className="w-full max-w-full px-4 text-center">
            <Link
              to={one_pms_pos_and_tour_booking_platform_button_url}
              className="inline-block text-lg font-bold leading-6 text-white bg-[#5FA3B2] border border-[#5FA3B2] py-[17px] px-[35px] rounded-xl transition-all ease-in-out duration-500 hover:border-[#faa42a] hover:bg-[#faa42a] mb-2"
            >
              {one_pms_pos_and_tour_booking_section_button_text}
            </Link>


            <p className="text-lg font-normal leading-7 text-[#333333]">
              {one_pms_pos_and_tour_booking_section_tag_line_text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IntroducingSection;
